/** App → marketing site base URL (cross-origin in production). */
export const MARKETING_HOME =
  process.env.REACT_APP_MARKETING_URL || "https://kontomatch.com";
